module.exports = __webpack_public_path__ + "img/map@2x.9f3fae56.png";